import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SidebarProvider } from './context/SidebarContext';
import Login from './components/Login';
import Register from './components/Register';
import MainLayout from './components/Layout/MainLayout';
import Dashboard from './pages/Dashboard';
import Stock from './pages/Stock';
import HonestMark from './pages/HonestMark';
import Profile from './components/Profile';
import AdminPanel from "./components/AdminPanel";
import Stocks from "./components/Stocks/Stocks";
import StocksMobile from "./components/Stocks/StocksMobile";
import OzoneOrders from './components/Orders/OzoneOrders';
import OzoneOrdersMobile from './components/Orders/OzoneOrdersMobile';
import WBOrders from './components/Orders/WBOrders';
import BananasGPT from './pages/BananasGPT';
import Reviews from './pages/Reviews';
import ReviewReplyTemplates from './pages/ReviewReplyTemplates';
import ReviewAiLearn from './pages/ReviewAiLearn';
import Messages from './pages/Messages';
import ScannerMobile from './components/Scanner/ScannerMobile';
import OzonProductSync from './components/Stocks/OzonProductSync';
import StockReturns from './components/Stocks/StockReturns';
import ProductCost from './components/Cost/ProductCost';
import CostMaterials from './components/Cost/CostMaterials';
import OzonActions from './pages/OzonActions';
import OzonPrices from './pages/OzonPrices';
const PrivateRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return <div className="min-h-screen flex items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
        </div>;
    }

    if (!user) {
        return <Navigate to="/login" />;
    }

    return children;
};

const App = () => {
    return (
        <Router>
            <AuthProvider>
                <SidebarProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/" element={
                            <PrivateRoute>
                                <MainLayout />
                            </PrivateRoute>
                        }>


                            <Route path="/orders/wb" element={<WBOrders />} />
                            <Route index element={<Navigate to="/dashboard" replace />} />
                            <Route path="dashboard" element={<Dashboard />} />
                            <Route path="admin" element={<AdminPanel />} />
                            {/*<Route path="stock" element={<Stock />} />*/}
                            <Route path="/stock" element={<Stocks />} />
                            <Route path="/stocksm" element={<StocksMobile />} />
                            <Route path="stock/returns" element={<StockReturns />} />
                            <Route path="ozon/sync" element={<OzonProductSync />} />
                            <Route path="честный-знак" element={<HonestMark />} />
                            <Route
                                path="bananas-gpt"
                                element={<Navigate to="/bananas-gpt/openrouter" replace />}
                            />
                            <Route path="bananas-gpt/openrouter" element={<BananasGPT />} />
                            <Route path="bananas-gpt/nanogpt" element={<BananasGPT />} />
                            <Route path="orders/ozon" element={<OzoneOrders />} />
                            <Route path="orders/ozonm" element={<OzoneOrdersMobile />} />
                            <Route path="scanner" element={<ScannerMobile />} />
                            <Route path="reviews" element={<Reviews />} />
                            <Route path="reviews/templates" element={<ReviewReplyTemplates />} />
                            <Route path="reviews/ai-learn" element={<ReviewAiLearn />} />
                            <Route path="messages" element={<Messages />} />
                            <Route path="cost" element={<ProductCost />} />
                            <Route path="cost/materials" element={<CostMaterials />} />
                            <Route path="actions/ozon" element={<OzonActions />} />
                            <Route path="actions/prices" element={<OzonPrices />} />
                            <Route path="profile" element={<Profile />} />
                        </Route>
                    </Routes>
                </SidebarProvider>
            </AuthProvider>
        </Router>
    );
};

export default App;
